import { simpleSet } from '@r/reducers/utils';

const setVisible = simpleSet as redux.reducers.modals.object3dModal.visible;

export const visible = setVisible( 'SET_OBJECT_3D_MODAL_VISIBLE', false );
